import { DatePicker, Divider, Form, FormInstance, Space } from 'antd';
import dayjs from 'dayjs';

import { disabledPastDates, disabledPastTimes, roundedDate } from 'utils/date';

const MINUTE_STEP = 10;

type ValidityFieldsProps = {
  form: FormInstance;
};

export const ValidityFields = ({ form }: ValidityFieldsProps) => {
  const workTimeInterval = Form.useWatch('workTimeInterval', form);

  return (
    <>
      <Divider plain>Период действия рекомендации</Divider>
      <Form.Item
        label={'Выберите даты'}
        validateTrigger={'onBlur'}
        name="workTimeInterval"
        required={true}
        dependencies={[
          ['workTimeInterval', 'from'],
          ['workTimeInterval', 'to'],
        ]}
        rules={[
          (form) => ({
            validator: (_, value = {}) => {
              const { from, to } = value;
              if ((!from && !!to) || (!from && !to)) {
                return Promise.reject('Дата начала обязательное поле');
              } else if (!!from && !!to && dayjs(to).isSame(dayjs(from), 'minute')) {
                return Promise.reject('Даты должны различаться');
              } else if (!!from && !!to && dayjs(to).isBefore(dayjs(from), 'minute')) {
                return Promise.reject('Начальная дата не может быть позже конечной');
              }
              return Promise.resolve();
            },
          }),
        ]}
      >
        <Form.Item noStyle>
          <Space direction={'horizontal'} split={<Divider type="vertical" />}>
            <Form.Item noStyle name={['workTimeInterval', 'from']}>
              <DatePicker
                placeholder="Дата начала"
                showTime={{
                  format: 'HH:mm',
                  // minuteStep: MINUTE_STEP,
                  // defaultValue: roundedDate(MINUTE_STEP * 60 * 1000),
                }}
                format="DD MMM YYYY HH:mm"
                disabledDate={(date) => disabledPastDates(date, dayjs())}
                disabledTime={(date) => disabledPastTimes(date, dayjs(), MINUTE_STEP * 60 * 1000)}
                showNow={false}
                showToday={false}
              />
            </Form.Item>
            <Form.Item noStyle name={['workTimeInterval', 'to']}>
              <DatePicker
                placeholder="Дата окончания"
                showTime={{
                  format: 'HH:mm',
                  minuteStep: MINUTE_STEP,
                  defaultValue: roundedDate(MINUTE_STEP * 60 * 1000, workTimeInterval?.from || dayjs()),
                }}
                format="DD MMM YYYY HH:mm"
                disabledDate={(date) => disabledPastDates(date, workTimeInterval?.from)}
                disabledTime={(date) =>
                  disabledPastTimes(date, workTimeInterval?.from || dayjs(), MINUTE_STEP * 60 * 1000)
                }
                showNow={false}
                showToday={false}
              />
            </Form.Item>
          </Space>
        </Form.Item>
      </Form.Item>
    </>
  );
};
